


























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ColorPicker from "@/commonComponents/colorPicker/colorPicker.vue";
import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";
import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";
import GradientSelector from "./gradientSelector/gradientSelector.vue";
import RangeSlider from "@/components/VRangeSliderStyling.vue";

import * as Enumerable from "linq-es5";

import * as def from "@/definitions";

import { Design } from "@/model/document2/page/surface/design/design";
import { PatternBaseLayer } from "@/model/document2/page/surface/design/layer/patternBaseLayer";
import { RectangleLayer } from "@/model/document2/page/surface/design/layer/rectangleLayer";
import { CircleLayer } from "@/model/document2/page/surface/design/layer/circleLayer";
import { PolygonLayer } from "@/model/document2/page/surface/design/layer/polygonLayer";
import { ColorConstruct } from "@/utilityModels/colorConstruct";

import { MathHelper } from "@/helper/mathHelper";

import ColorSelector from "@/commonComponents/colorSelector/colorSelector.vue";

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import RadioOn from "../resources/radioOn.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
    ColorPicker,
    DropdownList,
    RangeSlider,
    ValueEdit,
    GradientSelector,
    ColorSelector,
    ArrowDown,
    ArrowRight,
    RadioOn
  }
})
export default class MultiplePatternColorFillGradient extends Vue
{
    @Prop() private design!: Design;

    //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
    //こいつはpropsでもらいたい
    openStatus = {
        opend: true
    };

    multiplePatternColorFillGradientContentsOpenAnimate = false;
    multiplePatternColorFillGradientContentsCloseAnimate = false;

    open() {
        if (this.openStatus.opend) {
            this.multiplePatternColorFillGradientContentsCloseAnimate = true;
            setTimeout(() => {
                this.multiplePatternColorFillGradientContentsCloseAnimate = false;
                this.multiplePatternColorFillGradientContentsOpenAnimate = false;
                this.openStatus.opend = false;
            }, 200);
        } else {
            this.openStatus.opend = true;
            this.multiplePatternColorFillGradientContentsOpenAnimate = true;
            setTimeout(() => {
                this.multiplePatternColorFillGradientContentsOpenAnimate = false;
            }, 250);
        }
    }
    //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

    // すべてのレイヤーの特定のパラメータを取得する。
    // 一致していなければ null を返す
    private getLayerProperty(property : string) : any
    {
        var value : any = null;
        var isBreak : boolean = false;

        var allLayers = this.design.getSelectLayerWithoutGroup();
        for(var i = 0; i < allLayers.length; ++i)
        {
            var layer = allLayers[i];
            if(layer instanceof RectangleLayer || layer instanceof CircleLayer || layer instanceof PolygonLayer)
            {
                var val = layer[property];
                if(val != null)
                {
                    if(value == null) { value = val; }
                    else if(typeof(value) == "number" && typeof(val) == "number" && MathHelper.equals(value, val)) { value = val; }
                    else if(value instanceof ColorConstruct && val instanceof ColorConstruct && value.equals(val)) { value = val; }
                    else if(value === val) { value = val; }
                    else
                    {
                        isBreak = true;
                        break;
                    }
                }
            }
            if(isBreak) { break; }
        }

        if(isBreak) { return null; }

        return value;
    }

    //↓↓↓↓↓透明度↓↓↓↓↓
    private get opacity()
    {
        var value = this.getLayerProperty("opacity");
        return value != null && typeof(value) == "number" ? value : 100;
    }
    private get opacitySliderValue()
    {
        return this.opacity;
    }
    private set opacitySliderValue(value)
    {
        this.changeLayerProperty(value, "opacity", false);
    }
    private onChangeOpacity(value)
    {
        this.changeLayerProperty(value, "opacity", true);
    }
    //↑↑↑↑↑透明度↑↑↑↑↑

    //↓↓↓↓↓塗りつぶしタイプ変更↓↓↓↓↓
    private changeFillType(fillType: string) {
        var layerFillType = 0;
        if (fillType == "none") {
            layerFillType = 0;
        } else if (fillType == "solid") {
            layerFillType = 1;
        } else if (fillType == "gradient") {
            layerFillType = 2;
        }

        this.changeLayerProperty(layerFillType, "fillType", true, true);
    }
    //↑↑↑↑↑塗りつぶしタイプ変更↑↑↑↑↑

    private changeLayerProperty(value: any, propertyName: string, isFinish : boolean = false, isOnce : boolean = false)
    {
        var layers = this.design.getSelectLayerWithoutGroup();

        for(var i = 0; i < layers.length; ++i)
        {
            var layer = layers[i];

            this.$emit("doCommand", "changeLayerProperty", {
                layer : layer,
                propertyName : propertyName,
                value : value,
                isFinish : (isFinish || isOnce) && i == layers.length - 1,
                isOnce : false
            });
        }
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }
    private get userConfigFontColor(){
        var style = {
            color : this.userConfigColor
        };
        return style;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
